module.exports = __webpack_public_path__ + "static/media/snowflake-blue.ab8a3d5d.svg";